import { useEffect, useRef } from 'react'

import { isPhaseCompleted } from '../../RequestProfileTabActivities.utils'

export function useAutoCollapseOnPhaseCompleted({
  isOpen,
  phase,
  onToggleOpen,
}) {
  const wasCompletedRef = useRef(isPhaseCompleted(phase))

  useEffect(() => {
    const isCompleted = isPhaseCompleted(phase)

    if (isOpen && isCompleted && !wasCompletedRef.current) {
      onToggleOpen(phase.id)
    }

    wasCompletedRef.current = isCompleted
  }, [isOpen, onToggleOpen, phase])
}
